module.exports = __webpack_public_path__ + "static/media/Feb_2026_2.4feed3e9.webp";